import { Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { ProtectedRoute } from '@/components/routing';

// Lazy load enterprise pages
const EnterpriseDashboard = lazy(() => import('@/pages/EnterpriseDashboard'));
const EnterpriseLearnerDetail = lazy(() => import('@/pages/EnterpriseLearnerDetail'));
const OrganizationPage = lazy(() => import('@/pages/OrganizationPage'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    Chargement...
  </div>
);

export function EnterpriseRoutes() {
  return (
    <>
      <Route 
        path="/enterprise" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <EnterpriseDashboard />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/enterprise/learners/:learnerId" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <EnterpriseLearnerDetail />
            </Suspense>
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/organization" 
        element={
          <ProtectedRoute>
            <Suspense fallback={<PageLoader />}>
              <OrganizationPage />
            </Suspense>
          </ProtectedRoute>
        } 
      />
    </>
  );
}
